<template>
    <div>
        <div class="choose-box-new">
            <img :src="getImageUrl" alt="" class="choose-box-new--image" :class="{'pop-image' : !isPopEnabled}">
            <div class="choose-box-new--container" :class="{'choose-box-pop' : !isPopEnabled}">
                <div v-for="(item, index) in products" :key="index" class="choose-box-new--container--section">
                  <div v-if="item.enabled">
                    <h1 class="choose-box-new--container--section--heading">{{ item.boxName}}</h1>
                    <h3 class="choose-box-new--container--section--sub-heading">{{ `${currency}${getProductPrice(item.type)}` }}</h3>
                    <p class="choose-box-new--container--section--text" v-html="item.description"></p>
                    <button class="btn btn--primary-black" @click="selectBox(item.type)">{{$t('GIFTING_BUTTON_SELECT')}}</button>
                  </div>
                </div>
            </div>
            <div ref="card" class="choose-box-new--mobile-container">
                <div v-for="(item, index) in products" :key="index">
                    <div v-if="item.enabled" class="choose-box-new--card">
                        <img class="choose-box-new--card-image" :src='item.image_url' :alt="`${item.boxName} box image`">
                        <div class="choose-box-new--content">
                            <div>
                                <p class="choose-box-new--title">{{item.boxName}}</p>
                                <p class="choose-box-new--subTitle">{{ `${currency}${getProductPrice(item.type)}` }}</p>
                                <div class="choose-box-new--full-text">
                                    <p class="choose-box-new--text-size" v-html="item.description"></p>
                                </div>
                            </div>
                            <button class="btn btn--primary-black choose-box-new--card-button" @click="selectBox(item.type)">{{$t('GIFTING_BUTTON_SELECT')}}</button>
                        </div>
                    </div>
                </div>
            </div>
            <p class="choose-box-new--container--section--text text-center">{{ $t('GIFTING_BUMPER_BOX_INFO')}}</p>
        </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import { CSPageEvents } from '@/helpers/GAHelpers';
import { SECTION_CHOOSE_A_BOX_TYPE, PRODUCT_TYPE_SINGLE, PRODUCT_TYPE_BUMPER_SINGLE, DISPLAY_NAME_BUMPER, PRODUCT_TYPE_POP_SINGLE } from '@/constants/Gifting';

export default {
    name: 'ChooseYourBoxType',
    data() {
        return {
            boxTypeSelected: PRODUCT_TYPE_SINGLE,
            bumperBoxName: DISPLAY_NAME_BUMPER,
        };
    },
    mounted() {
        this.boxTypeSelected = this.selectedBoxName || PRODUCT_TYPE_SINGLE;
        this.isPopEnabled && (this.$refs.card.scrollLeft += 145);
    },
    computed: {
        ...mapGetters({
            deliveryType: 'gifting/getDeliveryType',
            selectedBoxName: 'gifting/getSelectedBoxName',
            defaultProductFamily: 'register/getDefaultProductFamily',
            currency: 'localisation/getCurrency',
            products: 'gifting/getGiftProducts',
            isPopEnabled: 'account/getPopSingleGift',
        }),
        standardBoxOption() {
            return PRODUCT_TYPE_SINGLE;
        },
        boxTypeTextOnMobile() {
            return this.boxTypeSelected === PRODUCT_TYPE_BUMPER_SINGLE ? 'GIFTING_BUMPER_BOX_TEXT' : 'GIFTING_STANDARD_BOX_TEXT';
        },
        bumperBoxOption() {
            return PRODUCT_TYPE_BUMPER_SINGLE;
        },
        getImageUrl() {
            return this.isPopEnabled ? 'https://freddiesflowers-com.s3.eu-west-2.amazonaws.com/images/gifting/Gifting-Web-Pop-SD-SS.jpg' : 'https://freddiesflowers-com.s3.eu-west-2.amazonaws.com/images/gifting/Gifting-Web-SD-SS.jpg';
        },
        selectedBoxPrice() {
            let boxSelected = (this.boxTypeSelected === PRODUCT_TYPE_BUMPER_SINGLE) ? PRODUCT_TYPE_BUMPER_SINGLE : PRODUCT_TYPE_SINGLE;
            return this.getProductPrice(boxSelected);
        },
        oneOffGiftPrice() {
            return parseInt(this.$store.getters['gifting/getProductTypePriceFromName'](PRODUCT_TYPE_SINGLE) || 0);
        },
        bumperBoxPrice() {
            return parseInt(this.$store.getters['gifting/getProductTypePriceFromName'](PRODUCT_TYPE_BUMPER_SINGLE) || 0);
        },
        standardBoxSelected() {
            return this.boxTypeSelected === PRODUCT_TYPE_SINGLE;
        },
        bumperBoxSelected() {
            return this.boxTypeSelected === PRODUCT_TYPE_BUMPER_SINGLE;
        },
    },
    methods: {
        selectBox(val) {
            this.$store.commit('gifting/setSelectedBoxName', val);
            this.$store.commit('gifting/setSectionComplete', SECTION_CHOOSE_A_BOX_TYPE);
            this.$router.push({ name: 'account.gifting.delivery-address' });
            CSPageEvents('giftOneOff', {
                productType: 'gift',
                productName: 'oneOff',
                productCategory: 'oneOffGift',
                productFamily: this.selectedBoxName || this.defaultProductFamily,
                frequency: 'once',
            });
        },
        boxTypeSelect() {
            this.selectBox(this.boxTypeSelected);
        },
        selectStandard() {
            this.boxTypeSelected = PRODUCT_TYPE_SINGLE;
        },
        selectBumper() {
            this.boxTypeSelected = PRODUCT_TYPE_BUMPER_SINGLE;
        },
        getProductPrice(productName) {
            return productName && parseInt(this.$store.getters['gifting/getProductTypePriceFromName'](productName) || 0);
        },
    },
};
</script>

<style lang="scss" scoped>
.choose-box-new {
    margin: 0 auto;
    max-width: 1008px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    &--image {
        @media (max-width: 1024px) {
            display: none;
        }
    }
    &--container {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        &--info {
            text-align: center;
            margin-bottom: 10px ;
            font-size: 15px;
            @media (max-width: 1024px) {
                display: none;
            }
        }
        &--section {
            padding: 20px;
            min-height: 192px;
            min-width: 320px;
            &--heading {
                font-size: 30px;
            }
            &--sub-heading {
                margin: 20px auto;
            }
            &--text {
                font-size: 16px;
                margin: 20px auto;
            }
            button {
                min-width: 200px;
            }
        }
        @media (max-width: 1024px) {
            display: none;
        }
    }

    &--mobile-container {
        padding: 0;
        display: none;
        overflow-x: scroll;
        scroll-behavior: smooth;
        scroll-snap-type: x mandatory;
        scroll-padding: 15vw;
        height: 100%;
        gap: 18px;
        @media (max-width: 1024px) {
            display: flex;
        }
        @media (max-width: 768px) {
            width: 100vw;
            height: 100%;
        }
    }

    &--card {
        scroll-snap-align: start;
        border: 1px solid #CECECE;
        border-radius: 8px;
        padding: 5px 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        max-width: 253px;
        height: 100%;
        padding-bottom: 27px;
        @media (min-width: 740px) {
            min-width: calc(33% - 10px);
        }
    }

    &--card-image {
        width: 100%;
        height: 172px;
        margin: 5px auto;
    }

    &--content {
        display: flex;
        flex-direction: column;
        height: 100%;
        margin-left: 0;
        text-align: center;
        justify-content: space-between;
    }

    &--title {
        font-weight: 400;
        font-size: 20px;
        line-height: 24px;
        text-align: center;
    }

    &--subTitle {
        font-size: 18px;
        line-height: 20px;
        text-align: center;
    }

    &--full-text {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    &--text-size {
        font-size: 18px;
        font-weight: 300px;
        padding-bottom: 39px;
        line-height: 24px;
        padding-bottom: 4px;
    }

    &--card-button {
        @media (max-width: 1024px) {
            min-width: 221px;
        }
    }
}
.choose-box-pop {
    margin-left: -10pc;
    margin-right: 8pc;
}
.pop-image {
    max-width: 660px;
}
</style>
